export enum FieldTypeTarget {
  Grid = "grid",
  Form = "form",
  Filter = "filter",
}
